import React, { useEffect } from 'react';
import '../../Styles/Modals/ConfirmationModal.css';
import { useWindow } from '../../contexts/WindowContext';

export const ConfirmationModal: React.FC = () => {
    const { confirmationModalState, closeConfirmationModal } = useWindow();
    useEffect(() => {
      const handleEscape = (e: KeyboardEvent) => {
        if (e.key === 'Escape') closeConfirmationModal();
      };
  
      if (confirmationModalState.isOpen) {
        document.addEventListener('keydown', handleEscape);
        return () => document.removeEventListener('keydown', handleEscape);
      }
      return undefined; // Return a function or undefined for the cleanup
    }, [confirmationModalState.isOpen, closeConfirmationModal]);
    if (!confirmationModalState.isOpen) return null;
  
    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) closeConfirmationModal();
    };
  
    return (
      <div 
        className="confirmation-modal-overlay"
        onClick={handleOverlayClick}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        <div className="confirmation-modal-content">
          <div className="confirmation-modal-text-section">
            <p className="confirmation-modal-text">{confirmationModalState.text}</p>
            {confirmationModalState.text2 && <p className="confirmation-modal-subtext">{confirmationModalState.text2}</p>}
          </div>
          <div className="confirmation-modal-actions">
            <button 
              className="confirmation-cancel-button"
              onClick={closeConfirmationModal}
              autoFocus
            >
              Cancel
            </button>
            <button 
              className="confirmation-confirm-button"
              onClick={(e) => {
                e.stopPropagation();
                confirmationModalState.onConfirm();
                closeConfirmationModal();
              }}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    );
  }